export default defineNuxtPlugin(() => {
  if (process.env.NODE_ENV !== 'production') return;

  // wcslog.js 스크립트 삽입
  const scriptTag = document.createElement('script');
  scriptTag.type = 'text/javascript';
  scriptTag.src = '//wcs.naver.net/wcslog.js';
  document.head.appendChild(scriptTag);

  // wcs_do() 호출은 wcs가 로드된 뒤에 실행해야 함
  scriptTag.onload = () => {
    if (typeof window.wcs_add === 'undefined') {
      window.wcs_add = {};
    }
    window.wcs_add['wa'] = '50c6cb28617ec8';

    if (window.wcs) {
      window.wcs_do();
    }
  };
});